import React from 'react'
import currentUserHasAccess from "../../../../util/widget-helper";
import {TREATMENT_CLASSIFICATION_WIDGET_CONTAINER,} from "../../../process/ui-definition/process-ui";
import ContentBox from "../../../layout/component/ContentBox";
import Row from "../../../bootstrap/component/Row";
import Column from "../../../bootstrap/component/Column";
import Select from "../../../form/component/Select";
import ValidationMessageList from "../../../validation/component/ValidationMessageList";
import LabelInput from '../../../form/component/LabelInput'

const TREATMENT_TYPES = [
    {
        id: 'noclassification',
        value: 'No classification',
    },
    {
        id: 'medical',
        value: 'Medical',
    },
    {
        id: 'nonmedical',
        value: 'Non-Medical',
    },
];

const TREATMENT_REASONS = [
    {
        id: '',
        value: '',
    },
    {
        id: 'Anterior Crossbite',
        value: 'Anterior Crossbite'
    },
    {
        id: 'Crowding / > KIG 2',
        value: 'Crowding / > KIG 2'
    },
    {
        id: 'Increased overjet due to protruded anterior teeth',
        value: 'Increased overjet due to protruded anterior teeth'
    },
    {
        id: 'Crowding in combination with rotation',
        value: 'Crowding in combination with rotation'
    },
    {
        id: 'Labial or palatal tilting of teeth',
        value: 'Labial or palatal tilting of teeth'
    },
    {
        id: 'Premature contacts',
        value: 'Premature contacts'
    },
    {
        id: 'Diastema',
        value: 'Diastema'
    },
    {
        id: 'Pre-prosthetic orthodontic treatment',
        value: 'Pre-prosthetic orthodontic treatment'
    }
];

const TreatmentClassification = ({treatmentPlan, saveTreatmentPlan, changeTreatmentPlan, validationMessageList}) => {
    if (!currentUserHasAccess(TREATMENT_CLASSIFICATION_WIDGET_CONTAINER)) {
        return null
    }

    const {treatmentType} = treatmentPlan;

    return (
        <div className="instructions w-treatment-duration">
            <ContentBox title="Medical/Non Medical Treatment Classification">
                <Row>
                    <Column size={12}>
                        <ValidationMessageList
                            validationMessageList={validationMessageList}
                        />
                    </Column>
                </Row>
                <Row className="w-td-panel">
                    <Column size={6}>
                        <LabelInput label="Treatment type">
                            <Select object={treatmentPlan} name="treatmentType"
                                    valueList={TREATMENT_TYPES}
                                    onChange={(name, value) => {
                                        changeTreatmentPlan(name, value)
                                        saveTreatmentPlan()
                                    }}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        {
                            treatmentType === "medical" ?
                                <LabelInput label="Treatment reason">
                                            <Select object={treatmentPlan} name="treatmentReason"
                                                    valueList={TREATMENT_REASONS}
                                                    onChange={(name, value) => {
                                                        changeTreatmentPlan(name, value)
                                                        saveTreatmentPlan()
                                                    }}
                                            />
                                </LabelInput>
                                : ""
                        }
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}


TreatmentClassification.propTypes = {}

export default TreatmentClassification



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/TreatmentClassification.js